import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api.js';
import * as OpenCC from 'opencc-js';
import { ref } from 'vue';
import Swal from 'sweetalert2';
const converter = OpenCC.Converter({ from: 'cn', to: 'tw' });
export function useAll() {
  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const isPlaying = ref(false);

  const getTTSUrl = (gender, result) => {
    let path = `/ai/tts`;
    if (route.name === 'ChatAIJp') {
      path += `/?lang=ja-JP`
    } else if (route.name === 'ChatAIFr') {
      path += `/?lang=fr-FR`
    } else {
      path += `/?lang=${store.state.selectedAccent}`
    }

    return api
      .post(path, { text: result, gender: gender || 'female', kid: false })
      .then((res) => res.data.url)
      .catch(() => '');
  };

  const get_Translate_Dialog = (theme, context, result) => {
    let path = `/ai/generate/15044d0c-2c65-4e1c-81bd-b57f0983686e`;
    if (route.name === 'ChatAIJp') {
      path = `/ai/generate/d4e0a2ad-0a5a-49dc-aaef-11f370b31462`
    }
    if (route.name === 'ChatAIFr') {
      path = `/ai/generate/19a48719-5e17-48a9-8d4d-56acca96d39d`
    }
    return api
      .post(path, {
        content: result,
        theme: theme,
        context: context
      })
      .then((res) => converter(res.data.result))
      .catch(() => {});
  };

  const getTranslateSpeech = (result) => {
    const path = `/ai/generate/e3714685-1955-4f85-bc73-5652ff3fc80d`;

    return api
      .post(path, { content: result })
      .then((res) => converter(res.data.result))
      .catch(() => {});
  };

  const playAudioStandard = (dynamicId) => {
    const audioPlayer = document.querySelector(`#playBtn${dynamicId}`);
    if (audioPlayer) {
      audioPlayer.onplaying = () => (isPlaying.value = true);
      audioPlayer.onpause = () => (isPlaying.value = false);

      if (isPlaying.value) {
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
        isPlaying.value = false;
      } else {
        audioPlayer.play();
        isPlaying.value = true;
      }
    }
  };

  const copyTextSelection = (text) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };

  const objIsEmpty = (obj) => !obj || Object.keys(obj).length === 0;

  const isNotEmpty = (array) => array.every((obj) => Object.keys(obj).length !== 0);

  const generateCheck = () =>
    Swal.fire({
      title: '提醒',
      html: `目前總點數：<span class="gept_main_color9">${100}</span> 點<br/>每次交卷看報告隨即扣除 1 點。`,
      showCloseButton: true,
      confirmButtonText: `我知道了`,
      customClass: {
        popup: 'p-0',
        htmlContainer: 'p-4 font-bold leading-loose',
        confirmButton: 'denyButton-gept',
      },
    }).then((result) => result.isConfirmed);

  const getItemRecords = (id, item_id) => {
    let path = `/books/${id}/items/${item_id}`

    return api
      .get(path)
      .then((res) => res.data)
      .catch(() => {
        router.push({ name: 'myList' })
      })
  }

  const postItemRecords = (id, item_id, text) => {
    let path = `/books/${id}/items/${item_id}/record`;
    const formData = new FormData();
    formData.append('text', text);

    return api
      .post(path, formData)
      .then(() => getItemRecords(id, item_id))
      .catch(() => {});
  };

  const infoFunc = () => {
    Swal.fire({
      html: `<h6 class="mb-3 ai_text_06 text-xl">全新AI學習網上線了</h6>
      <div class="flex justify-center">
        <ul class="text-left list-decimal leading-relaxed text-lg">
          <li>第一次使用請先註冊並登入LiveABC會員。</li>
          <li>於輸入雜誌最後一頁之序號或書籍之數位產品序號卡進行兌換。</li>
          <li>相關使用規範請參照各書後方注意事項。</li>
          <li>請使用Chrome或Safari輸入網址https://elearning.liveabc.com使用本網站服務。</li>
        </ul>
      </div>
`,
      showCloseButton: false,
      focusConfirm: false,
      confirmButtonText: `確認`,
      title: '使用說明',
      customClass: {
        title: 'text-white text-2xl ai_bg_01 font-semibold pb-4',
        container: '',
        popup: 'p-0',
        header: 'swal-header-notice justify-center items-center',
        closeButton: '',
        htmlContainer: 'my-3 font-semibold px-12',
        actions: 'mb-4 mt-2',
        confirmButton: 'ai_bg_01 px-36',
        cancelButton: 'bg-red-main-ai',
      }
    })
  }

  return {
    getTTSUrl,
    get_Translate_Dialog,
    getTranslateSpeech,
    playAudioStandard,
    copyTextSelection,
    objIsEmpty,
    isNotEmpty,
    generateCheck,
    isPlaying,
    getItemRecords,
    postItemRecords,
    infoFunc
  };
}
